import { CkmMixpanelLogsService } from '@shared-features/ckm-shared/_core/services/ckm-mixpanel-logs.service';
import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { CurrentUserService } from '@core/services';
import { CurrentUser } from '@shared/interfaces';
import { UserRoleEnum } from '@shared/enums';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuServicesComponent } from '@layout/components/menu-services/menu-services.component';
import { MenuSupportComponent } from '@layout/components/menu-support/menu-support.component';
import { MenuProfileComponent } from '@layout/components/menu-profile/menu-profile.component';
import { UserAvatarComponent } from '@layout/components/user-avatar.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss', './toolbar-mobile.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        TranslateModule,
        OverlayPanelModule,
        MenuServicesComponent,
        MenuSupportComponent,
        MenuProfileComponent,
        UserAvatarComponent,
    ],
})
export class ToolbarComponent {
    currentUser: CurrentUser | null = null;
    roles = UserRoleEnum;

    isSwitchGroupDisplayed = false;
    readonly ordersUrl = environment.ordersUrl;
    readonly quickorderMessagesUrl = environment.quickorderMessagesUrl;

    constructor(
        private currentUserService: CurrentUserService,
        private ckmMixpanelLogsService: CkmMixpanelLogsService
    ) {
        this.currentUser = this.currentUserService.getCurrentUser();
        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser = user;
        });
    }

    logHelpAndSupportNavButton() {
        this.ckmMixpanelLogsService.logHelpAndSupportNavButton();
    }
}
